export default __webpack_public_path__ + "static/media/on-sales.db2ebc5b.jpeg";